import { Exception } from './exception';

export class NullPointerException extends Exception {}
